// @flow

import type {ApiSuccess, PureAction} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';

import {ASYNC_TYPES, PURE} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const POST_PAYMENT_SEPA_VALIDATION =
  'v1/paymentTravel/POST_PAYMENT_SEPA_VALIDATION';
export const RESET_SEPA_VALIDATION = 'v1/paymentTravel/RESET_SEPA_VALIDATION';

export type PostSepaValidationSuccess = ApiSuccess<[], *>;

export const validateSepa = (token: string, iban: string): AsyncAction => {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  return {
    types: ASYNC_TYPES(POST_PAYMENT_SEPA_VALIDATION),
    callAPI: () =>
      axios
        .post(`${cfg.bookingServiceUrl}/payment/sepa/validate`, {iban}, config)
        .then((res) => res.data),
  };
};

export const resetSepaValidation = (): PureAction => ({
  type: PURE(RESET_SEPA_VALIDATION),
});
